export namespace BonusTypeId {
  export const Bet = 1n;
  export const Spin = 2n;
  export const Ticket = 3n;
}

export type BonusTypeType = (typeof BonusTypeId)[keyof typeof BonusTypeId];
